export default __webpack_public_path__ + "static/media/favorite.3c06ee4e.svg";